export const contextPurchase = {
    title: "Facture|Facture|Factures",
    'not-payed': "Vous n'avez pas encore acheté ce pack, donc pas de facture.",
    paying: "Une facture sera ajoutée dès la finalisation de votre achat."
}